import { render } from "./SubscribedPage.vue?vue&type=template&id=68b231f2&scoped=true"
import script from "./SubscribedPage.vue?vue&type=script&lang=js"
export * from "./SubscribedPage.vue?vue&type=script&lang=js"

import "./SubscribedPage.vue?vue&type=style&index=0&id=68b231f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b231f2"]])

export default __exports__